import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { EclassScaleService } from '@app/core/services';
import { safeEmptyList } from '@app/shared/utils';
import { first, isEmpty, size } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { SCORE_CONFIG, SidenavDailyShow } from './base';
import { SHARED_MODULES } from '@app/shared';
import { NgxCurrencyDirective } from 'ngx-currency';

export enum EvaluationType {
  Score = 'nota',
  Scale = 'escala',
}
const ONLY_SCORE = [EvaluationType.Score];
const EVALUATION_TYPE = [EvaluationType.Scale, EvaluationType.Score];
@Component({
  selector: 'app-sidenav-evaluation',
  imports: [SHARED_MODULES, NgxCurrencyDirective],
  templateUrl: './sidenav-evaluation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavEvaluationComponent implements OnDestroy {
  private readonly _eclassScaleService = inject(EclassScaleService);
  public readonly evaluation = EvaluationType;
  public readonly scoreConfig = SCORE_CONFIG;
  public scales$: Observable<any>;
  public form: FormGroup;
  private _targets$ = new BehaviorSubject<SidenavDailyShow[]>([]);

  @Input()
  public set targets(value: SidenavDailyShow[]) {
    this._targets$.next(value);
  }

  @Input()
  public set formGroup(value: FormGroup) {
    this.form = value;
    this.loadScale();
  }

  public ngOnDestroy() {
    this._targets$.complete();
  }

  public onReset() {
    this.form.get('score').reset();
  }

  public isEqual(type: EvaluationType, target: EvaluationType): boolean {
    return type === target;
  }

  public showError(ctrl: AbstractControl): boolean {
    return ctrl.invalid && ctrl.touched;
  }

  public showField(data: any[] = []): boolean {
    return size(data) > 1;
  }

  public labelType(type: EvaluationType): string {
    return `eclass.${type}`;
  }

  private loadScale() {
    this.scales$ = this._targets$.asObservable().pipe(
      filter((res) => !isEmpty(res)),
      map((target) => first(target)),
      switchMap((target) => this._eclassScaleService.index(target.entity.id).pipe(safeEmptyList())),
      map((scales) => ({
        types: isEmpty(scales) ? ONLY_SCORE : EVALUATION_TYPE,
        scales,
      })),
      tap(({ types }) => !this.form.get('type').value && this.form.get('type').setValue(first(types))),
    );
  }
}
